/** French Home Locator path used by drop-off prepopulation. */
const FRENCH_HOME_LOCATOR_BASE_URL =
  'https://www.purolator.com/fr/expedition/trouver-un-centre-dexpedition';

/**
 * Builds the Purolator.com Home Locator URL with the Ship From postal prepopulated.
 * Uses query param `postalcode` with spaces stripped; French locale uses the FR path.
 *
 * @param baseUrl - Environment Home Locator base URL (EN find-shipping-centre; no query string)
 * @param postalCode - Validated Ship From postal (spaces stripped before append)
 * @param language - Active UI locale; `fr` selects the French Home Locator path
 * @returns Absolute URL with `postalcode` query param, or empty string when inputs are missing
 */
export function buildHomeLocatorUrl(
  baseUrl: string,
  postalCode: string,
  language: 'en' | 'fr' = 'en',
): string {
  const trimmedBase = (language === 'fr' ? FRENCH_HOME_LOCATOR_BASE_URL : baseUrl).trim();
  const strippedPostal = postalCode.replace(/\s+/g, '');
  if (!trimmedBase || !strippedPostal) {
    return '';
  }

  const separator = trimmedBase.includes('?') ? '&' : '?';
  return `${trimmedBase}${separator}postalcode=${encodeURIComponent(strippedPostal)}`;
}
